import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import usePagination from './usePagination';
import { getPatientPendingAnswers } from '../services/patient';

const id = 'pending-answers';

export const usePatientPendingAnswers = (patientUUID) => {
    const {
        paginationModel,
        setPaginationModel,
        rowsPerPageOptions,
        count,
        currentToken,
        resolveHeader
    } = usePagination();

    const fetchData = async ({ queryKey }) => {
        const [, { patientUUID }] = queryKey;
        return getPatientPendingAnswers(
            patientUUID,
            paginationModel.pageSize,
            currentToken(paginationModel.page)
        );
    };

    const { data, isPending, isError } = useQuery({
        queryKey: [id, { patientUUID, paginationModel }],
        queryFn: fetchData,
        placeholderData: keepPreviousData,
        enabled: !!patientUUID
    });

    useEffect(() => {
        if (data) {
            resolveHeader(data.headers, paginationModel.page);
        }
    }, [data, paginationModel.page]);

    return {
        data: data?.data || [],
        isLoading: isPending,
        error: isError,
        count,
        rowsPerPageOptions,
        paginationModel,
        setPaginationModel
    };
};
